import gql from 'graphql-tag';

// Agency Reports (#36219). Both fields answer with a union: the response, or AgencyReportsError
// with a user-readable message (brand not configured, caller not allowed, key not a report).
export const LIST_AGENCY_REPORTS = gql`
  query ListAgencyReports($affinityStem: String) {
    listAgencyReports(affinityStem: $affinityStem) {
      __typename
      ... on AgencyReportsResponse {
        success
        affinityStem
        reports {
          key
          affinityStem
          fileName
          reportMonth
          reportType
        }
      }
      ... on AgencyReportsError {
        success
        error
      }
    }
  }
`;

export const GET_AGENCY_REPORT_DOWNLOAD_URL = gql`
  query GetAgencyReportDownloadUrl($key: String!) {
    getAgencyReportDownloadUrl(key: $key) {
      __typename
      ... on AgencyReportDownloadUrlResponse {
        success
        url
      }
      ... on AgencyReportsError {
        success
        error
      }
    }
  }
`;
